import dayjs from 'dayjs'
import { ref, computed } from 'vue'

export function useDateRangeFilter(defaultDays = 30) {
  const dateRange = ref<[Date, Date]>([
    dayjs().subtract(defaultDays, 'days').toDate(),
    dayjs().toDate(),
  ])

  const dateRangePresets = computed(() => [
    {
      label: 'Last 7 days',
      start: dayjs().subtract(7, 'days').toDate(),
      end: dayjs().toDate(),
    },
    {
      label: 'Last 30 days',
      start: dayjs().subtract(30, 'days').toDate(),
      end: dayjs().toDate(),
    },
    {
      label: 'Last 90 days',
      start: dayjs().subtract(90, 'days').toDate(),
      end: dayjs().toDate(),
    },
  ])

  return { dateRange, dateRangePresets }
}
